import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './pages/Index';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import ScrollToTopOnRouteChange from './components/common/ScrollToTopOnRouteChange';
import './assets/styles/navbar.css'
import './assets/styles/common.css'
import './assets/styles/contactUs.css'
import './assets/styles/footer.css'
import './assets/styles/terms.css'
import './assets/styles/privacyPolicy.css'
import './assets/styles/scrollToTop.css'

const App = () => {
  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <div>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
